import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "./config.js";
import { id as t } from "./kernel.js";
import r from "./core/Error.js";
import s from "./core/has.js";
import { clone as o } from "./core/lang.js";
import { unwrap as n } from "./core/maybe.js";
import { onAbort as a, isAbortError as i, createAbortError as l, isAborted as u } from "./core/promiseUtils.js";
import { isDataProtocol as c, isBlobProtocol as d, normalize as p, getInterceptor as m, isTrustedServer as h, getOrigin as f, toHTTPS as y, addQueryParameter as w, objectToQuery as g, getProxyRule as b, getProxyUrl as q, addQueryParameters as T, hasSameOrigin as k, appUrl as O, addProxyRule as S } from "./core/urlUtils.js";
import { supportsApiKey as x } from "./support/apiKeyUtils.js";
import { loadImageAsync as v } from "./support/requestUtils.js";

function C(_x, _x2) {
  return _C.apply(this, arguments);
}

function _C() {
  _C = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
    var r, o, i, l, u, _e2, h, f, y;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            o = c(e), i = d(e);
            i || o || (e = p(e));
            l = {
              url: e,
              requestOptions: _objectSpread({}, n(t))
            };
            u = m(e);

            if (!u) {
              _context.next = 11;
              break;
            }

            _context.next = 7;
            return K(u, l);

          case 7:
            _e2 = _context.sent;

            if (!(null != _e2)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", {
              data: _e2,
              getHeader: _,
              requestOptions: l.requestOptions,
              url: l.url
            });

          case 10:
            u.after || u.error || (u = null);

          case 11:
            if (!(e = l.url, "image" === (t = l.requestOptions).responseType)) {
              _context.next = 16;
              break;
            }

            if (!(s("host-webworker") || s("host-node"))) {
              _context.next = 14;
              break;
            }

            throw R("request:invalid-parameters", new Error("responseType 'image' is not supported in Web Workers or Node environment"), l);

          case 14:
            _context.next = 18;
            break;

          case 16:
            if (!o) {
              _context.next = 18;
              break;
            }

            throw R("request:invalid-parameters", new Error("Data URLs are not supported for responseType = " + t.responseType), l);

          case 18:
            if (!("head" === t.method)) {
              _context.next = 23;
              break;
            }

            if (!t.body) {
              _context.next = 21;
              break;
            }

            throw R("request:invalid-parameters", new Error("body parameter cannot be set when method is 'head'"), l);

          case 21:
            if (!(o || i)) {
              _context.next = 23;
              break;
            }

            throw R("request:invalid-parameters", new Error("data and blob URLs are not supported for method 'head'"), l);

          case 23:
            _context.next = 25;
            return H();

          case 25:
            if (!E) {
              _context.next = 27;
              break;
            }

            return _context.abrupt("return", E.execute(e, t));

          case 27:
            h = new AbortController();
            a(t, function () {
              return h.abort();
            });
            f = {
              controller: h,
              credential: null,
              credentialToken: null,
              fetchOptions: null,
              hasToken: !1,
              interceptor: u,
              params: l,
              redoRequest: !1,
              useIdentity: L.useIdentity,
              useProxy: !1,
              useSSL: !1,
              withCredentials: !1
            };
            _context.next = 32;
            return z(f);

          case 32:
            y = _context.sent;
            return _context.abrupt("return", (null == (r = u) || null == r.after || r.after(y), y));

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _C.apply(this, arguments);
}

var E;

var L = e.request,
    U = ("FormData" in globalThis),
    j = [499, 498, 403, 401],
    P = ["COM_0056", "COM_0057", "SB_0008"],
    D = [/\/arcgis\/tokens/i, /\/sharing(\/rest)?\/generatetoken/i, /\/rest\/info/i],
    _ = function _() {
  return null;
},
    F = Symbol();

function I(e) {
  var t = f(e);
  t && !C._corsServers.includes(t) && C._corsServers.push(t);
}

function M(e) {
  var t = f(e);
  return !t || t.endsWith(".arcgis.com") || C._corsServers.includes(t) || h(t);
}

function R(e, t, s, n) {
  var a = "Error";
  var u = {
    url: s.url,
    requestOptions: s.requestOptions,
    getHeader: _,
    ssl: !1
  };
  if (t instanceof r) return t.details ? (t.details = o(t.details), t.details.url = s.url, t.details.requestOptions = s.requestOptions) : t.details = u, t;

  if (t) {
    var _e = n && function (e) {
      return n.headers.get(e);
    },
        _r = n && n.status,
        _s = t.message;

    _s && (a = _s), _e && (u.getHeader = _e), u.httpStatus = (null != t.httpCode ? t.httpCode : t.code) || _r || 0, u.subCode = t.subcode, u.messageCode = t.messageCode, "string" == typeof t.details ? u.messages = [t.details] : u.messages = t.details, u.raw = F in t ? t[F] : t;
  }

  return i(t) ? l() : new r(e, a, u);
}

function H() {
  return _H.apply(this, arguments);
}

function _H() {
  _H = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!s("host-webworker")) {
              _context2.next = 8;
              break;
            }

            _context2.t0 = E;

            if (_context2.t0) {
              _context2.next = 6;
              break;
            }

            _context2.next = 5;
            return import("./core/workers/request.js");

          case 5:
            E = _context2.sent;

          case 6:
            _context2.next = 9;
            break;

          case 8:
            C._abortableFetch || (C._abortableFetch = globalThis.fetch.bind(globalThis));

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _H.apply(this, arguments);
}

function A() {
  return _A.apply(this, arguments);
}

function _A() {
  _A = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.t0 = t;

            if (_context3.t0) {
              _context3.next = 4;
              break;
            }

            _context3.next = 4;
            return import("./identity/IdentityManager.js");

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _A.apply(this, arguments);
}

function B(_x3) {
  return _B.apply(this, arguments);
}

function _B() {
  _B = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(r) {
    var s, o, n, a, i, l, c, _e3;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            s = r.params.url, o = r.params.requestOptions, n = r.controller.signal, a = o.body;
            i = null, l = null, c = null;

            if (!(U && "HTMLFormElement" in globalThis && (a instanceof FormData ? i = a : a instanceof HTMLFormElement && (l = a, i = new FormData(l))), "string" == typeof a && (c = a), r.fetchOptions = {
              cache: o.cacheBust && !C._abortableFetch.polyfill ? "no-cache" : "default",
              credentials: "same-origin",
              headers: o.headers || {},
              method: "head" === o.method ? "HEAD" : "GET",
              mode: "cors",
              redirect: "follow",
              signal: n
            }, (i || c) && (r.fetchOptions.body = i || c), "anonymous" === o.authMode && (r.useIdentity = !1), r.hasToken = !!(/token=/i.test(s) || o.query && o.query.token || i && i.get && i.get("token") || l && l.elements.token), !r.hasToken && e.apiKey && x(s) && (o.query || (o.query = {}), o.query.token = e.apiKey, r.hasToken = !0), r.useIdentity && !r.hasToken && !r.credentialToken && !N(s) && !u(n))) {
              _context4.next = 23;
              break;
            }

            if (!("immediate" === o.authMode)) {
              _context4.next = 12;
              break;
            }

            _context4.next = 6;
            return A();

          case 6:
            _context4.next = 8;
            return t.getCredential(s, {
              signal: n
            });

          case 8:
            _e3 = _context4.sent;
            r.credential = _e3;
            _context4.next = 22;
            break;

          case 12:
            if (!("no-prompt" === o.authMode)) {
              _context4.next = 21;
              break;
            }

            _context4.next = 15;
            return A();

          case 15:
            _context4.next = 17;
            return t.getCredential(s, {
              prompt: !1,
              signal: n
            }).catch(function () {});

          case 17:
            _e3 = _context4.sent;
            r.credential = _e3;
            _context4.next = 22;
            break;

          case 21:
            t && (_e3 = t.findCredential(s));

          case 22:
            _e3 && (r.credentialToken = _e3.token, r.useSSL = !!_e3.ssl);

          case 23:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _B.apply(this, arguments);
}

function N(e) {
  return D.some(function (t) {
    return t.test(e);
  });
}

function $(_x4) {
  return _$.apply(this, arguments);
}

function _$() {
  _$ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
    var r, o, n, a, i, u, p, _a, _i, _l, _u, _c, _e4, _e5, _s2, m, x, v, E, _e6, _e7;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            r = e.params.url;
            o = e.params.requestOptions, n = e.fetchOptions, a = d(r) || c(r), i = o.responseType || "json", u = a ? 0 : null != o.timeout ? o.timeout : L.timeout;
            p = !1;

            if (a) {
              _context5.next = 23;
              break;
            }

            e.useSSL && (r = y(r)), o.cacheBust && "default" === n.cache && (r = w(r, "request.preventCache", Date.now()));
            _a = _objectSpread({}, o.query);
            e.credentialToken && (_a.token = e.credentialToken);
            _i = g(_a);
            s("esri-url-encodes-apostrophe") && (_i = _i.replace(/'/g, "%27"));
            _l = r.length + 1 + _i.length;
            p = "delete" === o.method || "post" === o.method || "put" === o.method || !!o.body || _l > L.maxUrlLength;
            _c = o.useProxy || !!b(r);

            if (_c) {
              _e4 = q(r);
              _u = _e4.path, !p && _u.length + 1 + _l > L.maxUrlLength && (p = !0), _e4.query && (_a = _objectSpread(_objectSpread({}, _e4.query), _a));
            }

            if (!("HEAD" === n.method && (p || _c))) {
              _context5.next = 20;
              break;
            }

            if (!p) {
              _context5.next = 18;
              break;
            }

            if (!(_l > L.maxUrlLength)) {
              _context5.next = 17;
              break;
            }

            throw R("request:invalid-parameters", new Error("URL exceeds maximum length"), e.params);

          case 17:
            throw R("request:invalid-parameters", new Error("cannot use POST request when method is 'head'"), e.params);

          case 18:
            if (!_c) {
              _context5.next = 20;
              break;
            }

            throw R("request:invalid-parameters", new Error("cannot use proxy when method is 'head'"), e.params);

          case 20:
            if (p ? (n.method = "delete" === o.method ? "DELETE" : "put" === o.method ? "PUT" : "POST", o.body ? r = T(r, _a) : (n.body = g(_a), n.headers["Content-Type"] = "application/x-www-form-urlencoded")) : r = T(r, _a), _c && (e.useProxy = !0, r = "".concat(_u, "?").concat(r)), _a.token && U && n.body instanceof FormData) {
              _e5 = n.body;
              _e5.set ? _e5.set("token", _a.token) : _e5.append("token", _a.token);
            }

            if (o.hasOwnProperty("withCredentials")) e.withCredentials = o.withCredentials;else if (!k(r, O)) if (h(r)) e.withCredentials = !0;else if (t) {
              _s2 = t.findServerInfo(r);
              _s2 && _s2.webTierAuth && (e.withCredentials = !0);
            }
            e.withCredentials && (n.credentials = "include");

          case 23:
            v = 0, E = !1;
            u > 0 && (v = setTimeout(function () {
              E = !0, e.controller.abort();
            }, u));
            _context5.prev = 25;

            if (!("native-request-init" === o.responseType)) {
              _context5.next = 30;
              break;
            }

            x = n, x.url = r;
            _context5.next = 96;
            break;

          case 30:
            if (!("image" !== o.responseType || "default" !== n.cache || "GET" !== n.method || p || W(o.headers) || !a && !e.useProxy && L.proxyUrl && !M(r))) {
              _context5.next = 93;
              break;
            }

            _context5.next = 33;
            return C._abortableFetch(r, n);

          case 33:
            m = _context5.sent;
            e.useProxy || I(r);

            if (!("native" === o.responseType)) {
              _context5.next = 39;
              break;
            }

            x = m;
            _context5.next = 91;
            break;

          case 39:
            if (!("HEAD" !== n.method)) {
              _context5.next = 91;
              break;
            }

            if (!m.ok) {
              _context5.next = 88;
              break;
            }

            _context5.t0 = i;
            _context5.next = _context5.t0 === "array-buffer" ? 44 : _context5.t0 === "blob" ? 48 : _context5.t0 === "image" ? 48 : 52;
            break;

          case 44:
            _context5.next = 46;
            return m.arrayBuffer();

          case 46:
            x = _context5.sent;
            return _context5.abrupt("break", 55);

          case 48:
            _context5.next = 50;
            return m.blob();

          case 50:
            x = _context5.sent;
            return _context5.abrupt("break", 55);

          case 52:
            _context5.next = 54;
            return m.text();

          case 54:
            x = _context5.sent;

          case 55:
            if (!(v && (clearTimeout(v), v = 0), "json" === i || "xml" === i || "document" === i)) {
              _context5.next = 68;
              break;
            }

            if (!x) {
              _context5.next = 67;
              break;
            }

            _context5.t1 = i;
            _context5.next = _context5.t1 === "json" ? 60 : _context5.t1 === "xml" ? 62 : _context5.t1 === "document" ? 64 : 65;
            break;

          case 60:
            x = JSON.parse(x);
            return _context5.abrupt("break", 65);

          case 62:
            x = G(x, "application/xml");
            return _context5.abrupt("break", 65);

          case 64:
            x = G(x, "text/html");

          case 65:
            _context5.next = 68;
            break;

          case 67:
            x = null;

          case 68:
            if (!x) {
              _context5.next = 86;
              break;
            }

            if (!("array-buffer" === i || "blob" === i)) {
              _context5.next = 81;
              break;
            }

            _e6 = m.headers.get("Content-Type");

            if (!(/application\/json|text\/plain/i.test(_e6) && x["blob" === i ? "size" : "byteLength"] <= 750)) {
              _context5.next = 81;
              break;
            }

            _context5.prev = 72;
            _context5.next = 75;
            return new Response(x).json();

          case 75:
            _e7 = _context5.sent;
            _e7.error && (x = _e7);
            _context5.next = 81;
            break;

          case 79:
            _context5.prev = 79;
            _context5.t2 = _context5["catch"](72);

          case 81:
            _context5.t3 = "image" === i && x instanceof Blob;

            if (!_context5.t3) {
              _context5.next = 86;
              break;
            }

            _context5.next = 85;
            return X(URL.createObjectURL(x), e, !0);

          case 85:
            x = _context5.sent;

          case 86:
            _context5.next = 91;
            break;

          case 88:
            _context5.next = 90;
            return m.text();

          case 90:
            x = _context5.sent;

          case 91:
            _context5.next = 96;
            break;

          case 93:
            _context5.next = 95;
            return X(r, e);

          case 95:
            x = _context5.sent;

          case 96:
            _context5.next = 107;
            break;

          case 98:
            _context5.prev = 98;
            _context5.t4 = _context5["catch"](25);

            if (!("AbortError" === _context5.t4.name)) {
              _context5.next = 104;
              break;
            }

            if (!E) {
              _context5.next = 103;
              break;
            }

            throw new Error("Timeout exceeded");

          case 103:
            throw l("Request canceled");

          case 104:
            if (!(!(!m && _context5.t4 instanceof TypeError && L.proxyUrl) || o.body || "delete" === o.method || "head" === o.method || "post" === o.method || "put" === o.method || e.useProxy || M(r))) {
              _context5.next = 106;
              break;
            }

            throw _context5.t4;

          case 106:
            e.redoRequest = !0, S({
              proxyUrl: L.proxyUrl,
              urlPrefix: f(r)
            });

          case 107:
            _context5.prev = 107;
            v && clearTimeout(v);
            return _context5.finish(107);

          case 110:
            return _context5.abrupt("return", [m, x]);

          case 111:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[25, 98, 107, 110], [72, 79]]);
  }));
  return _$.apply(this, arguments);
}

function K(_x5, _x6) {
  return _K.apply(this, arguments);
}

function _K() {
  _K = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e, t) {
    var _o, _n;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(null != e.responseData)) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt("return", e.responseData);

          case 2:
            if (!(e.headers && (t.requestOptions.headers = _objectSpread(_objectSpread({}, t.requestOptions.headers), e.headers)), e.query && (t.requestOptions.query = _objectSpread(_objectSpread({}, t.requestOptions.query), e.query)), e.before)) {
              _context6.next = 15;
              break;
            }

            _context6.prev = 3;
            _context6.next = 6;
            return e.before(t);

          case 6:
            _n = _context6.sent;
            _context6.next = 12;
            break;

          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](3);
            _o = R("request:interceptor", _context6.t0, t);

          case 12:
            if (!((_n instanceof Error || _n instanceof r) && (_o = R("request:interceptor", _n, t)), _o)) {
              _context6.next = 14;
              break;
            }

            throw e.error && e.error(_o), _o;

          case 14:
            return _context6.abrupt("return", _n);

          case 15:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[3, 9]]);
  }));
  return _K.apply(this, arguments);
}

function W(e) {
  if (e) {
    var _iterator = _createForOfIteratorHelper(Object.getOwnPropertyNames(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _t = _step.value;
        if (e[_t]) return !0;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return !1;
}

function G(e, t) {
  var r;

  try {
    r = new DOMParser().parseFromString(e, t);
  } catch (_unused) {}

  if (!r || r.getElementsByTagName("parsererror").length) throw new SyntaxError("XML Parse error");
  return r;
}

function z(_x7) {
  return _z.apply(this, arguments);
}

function _z() {
  _z = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e) {
    var r, s, o, n, _yield$$, _yield$$2, _t2, a, _e8, i, _e9, _r2, _e10;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return B(e);

          case 2:
            _context7.prev = 2;

          case 3:
            _context7.next = 5;
            return $(e);

          case 5:
            _yield$$ = _context7.sent;
            _yield$$2 = _slicedToArray(_yield$$, 2);
            o = _yield$$2[0];
            n = _yield$$2[1];

          case 9:
            _context7.next = 11;
            return J(e, o, n);

          case 11:
            if (!_context7.sent) {
              _context7.next = 3;
              break;
            }

          case 12:
            _context7.next = 18;
            break;

          case 14:
            _context7.prev = 14;
            _context7.t0 = _context7["catch"](2);
            _t2 = R("request:server", _context7.t0, e.params, o);
            throw _t2.details.ssl = e.useSSL, e.interceptor && e.interceptor.error && e.interceptor.error(_t2), _t2;

          case 18:
            a = e.params.url;

            if (/\/sharing\/rest\/(accounts|portals)\/self/i.test(a) && !e.hasToken && !e.credentialToken && null != (r = n) && null != (s = r.user) && s.username && !h(a)) {
              _e8 = f(a, !0);
              _e8 && L.trustedServers.push(_e8);
            }

            i = e.credential;

            if (i && t) {
              _e9 = t.findServerInfo(i.server);
              _r2 = _e9 && _e9.owningSystemUrl;

              if (_r2) {
                _r2 = _r2.replace(/\/?$/, "/sharing");
                _e10 = t.findCredential(_r2, i.userId);
                _e10 && -1 === t._getIdenticalSvcIdx(_r2, _e10) && _e10.resources.unshift(_r2);
              }
            }

            return _context7.abrupt("return", {
              data: n,
              getHeader: o ? function (e) {
                return o.headers.get(e);
              } : _,
              requestOptions: e.params.requestOptions,
              ssl: e.useSSL,
              url: e.params.url
            });

          case 23:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[2, 14]]);
  }));
  return _z.apply(this, arguments);
}

function J(_x8, _x9, _x10) {
  return _J.apply(this, arguments);
}

function _J() {
  _J = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e, r, s) {
    var o, n, a, i, l, u, _r3;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!e.redoRequest) {
              _context8.next = 2;
              break;
            }

            return _context8.abrupt("return", (e.redoRequest = !1, !1));

          case 2:
            o = e.params.requestOptions;

            if (!(!r || "native" === o.responseType || "native-request-init" === o.responseType)) {
              _context8.next = 5;
              break;
            }

            return _context8.abrupt("return", !0);

          case 5:
            if (r.ok) {
              _context8.next = 7;
              break;
            }

            throw n = new Error("Unable to load ".concat(r.url, " status: ").concat(r.status)), n[F] = s, n;

          case 7:
            null != s && s.error && (n = s.error), n && (a = Number(n.code), i = n.hasOwnProperty("subcode") ? Number(n.subcode) : null, l = n.messageCode, l = l && l.toUpperCase());
            u = o.authMode;

            if (!(403 === a && (4 === i || n.message && n.message.toLowerCase().indexOf("ssl") > -1 && -1 === n.message.toLowerCase().indexOf("permission")))) {
              _context8.next = 14;
              break;
            }

            if (e.useSSL) {
              _context8.next = 12;
              break;
            }

            return _context8.abrupt("return", (e.useSSL = !0, !1));

          case 12:
            _context8.next = 29;
            break;

          case 14:
            if (!(!e.hasToken && e.useIdentity && ("no-prompt" !== u || 498 === a) && -1 !== j.indexOf(a) && !N(e.params.url) && (403 !== a || -1 === P.indexOf(l) && (null == i || 2 === i && e.credentialToken)))) {
              _context8.next = 29;
              break;
            }

            _context8.next = 17;
            return A();

          case 17:
            _context8.prev = 17;
            _context8.next = 20;
            return t.getCredential(e.params.url, {
              error: R("request:server", n, e.params),
              prompt: "no-prompt" !== u,
              signal: e.controller.signal,
              token: e.credentialToken
            });

          case 20:
            _r3 = _context8.sent;
            return _context8.abrupt("return", (e.credential = _r3, e.credentialToken = _r3.token, e.useSSL = e.useSSL || _r3.ssl, !1));

          case 24:
            _context8.prev = 24;
            _context8.t0 = _context8["catch"](17);

            if (!("no-prompt" === u)) {
              _context8.next = 28;
              break;
            }

            return _context8.abrupt("return", (e.credential = null, e.credentialToken = null, !1));

          case 28:
            n = _context8.t0;

          case 29:
            if (!n) {
              _context8.next = 31;
              break;
            }

            throw n;

          case 31:
            return _context8.abrupt("return", !0);

          case 32:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[17, 24]]);
  }));
  return _J.apply(this, arguments);
}

function X(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var s = t.controller.signal,
      o = new Image();
  return t.withCredentials ? o.crossOrigin = "use-credentials" : o.crossOrigin = "anonymous", o.alt = "", o.src = e, v(o, e, r, s);
}

C._abortableFetch = null, C._corsServers = ["https://server.arcgisonline.com", "https://services.arcgisonline.com"];
export { C as default };